import Vue from 'vue'

import router from "./router/index.js"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue'

Vue.use(ElementUI);

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
 

new Vue({
	el: '#app',
	router,
	render: h => h(App),
}).$mount('#app')





